import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "../../../node_modules/swiper/swiper-bundle.min.css";
import breastedsuit from "../../assets/cetagoris/breasted-suit.png";
import manShirt from "../../assets/cetagoris/man-shirt.png";
import manshoe from "../../assets/cetagoris/man-shoe.png";
import womanbag from "../../assets/cetagoris/woman-bag.png";
import womandress from "../../assets/cetagoris/woman-dress.png";
import Cetagorisv1 from "../cetagorisv1/Cetagorisv1";
import "./CetagorySliderv1.css";
const CetagorySliderv1 = () => {
  return (
    <Fragment>
      <div className={"categories-slider-v1"}>
        <Swiper
          loop={true}
          navigation={{
            prevEl: ".button-prev-slide1",
            nextEl: ".button-next-slide1",
          }}
          modules={[Navigation]}
          breakpoints={{
            576: {
              slidesPerView: 1,
              spaceBetween: 15,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 15,
            },
            991: {
              slidesPerView: 4,
              spaceBetween: 15,
            },
            1320: {
              slidesPerView: 5,
              spaceBetween: 15,
            },
          }}
        >
          <SwiperSlide>
            <Link to="#">
              <Cetagorisv1
                img={manShirt}
                title="Man Shirts"
                content="12 Available"
              />
            </Link>
          </SwiperSlide>
          <SwiperSlide>
            <Link to="#">
              <Cetagorisv1
                img={breastedsuit}
                title="Breasted Suit"
                content="32 Available"
              />
            </Link>
          </SwiperSlide>
          <SwiperSlide>
            <Link to="#">
              <Cetagorisv1
                img={manshoe}
                title="man shoe"
                content="55 Available"
              />
            </Link>
          </SwiperSlide>
          <SwiperSlide>
            <Link to="#">
              <Cetagorisv1
                img={womanbag}
                title="Woman Bag"
                content="19 Available"
              />
            </Link>
          </SwiperSlide>
          <SwiperSlide>
            <Link to="#">
              <Cetagorisv1
                img={womandress}
                title="Woman Dress"
                content="34 Available"
              />
            </Link>
          </SwiperSlide>
          <SwiperSlide>
            <Link to="#">
              <Cetagorisv1
                img={manShirt}
                title="Man Shirts"
                content="32 Available"
              />
            </Link>
          </SwiperSlide>
          <SwiperSlide>
            <Link to="#">
              <Cetagorisv1
                img={manShirt}
                title="Man Shirts"
                content="11 Available"
              />
            </Link>
          </SwiperSlide>
          <SwiperSlide>
            <Link to="#">
              <Cetagorisv1
                img={breastedsuit}
                title="Breasted Suit"
                content="34 Available"
              />
            </Link>
          </SwiperSlide>
          <SwiperSlide>
            <Link to="#">
              <Cetagorisv1
                img={manshoe}
                title="man shoe"
                content="23 Available"
              />
            </Link>
          </SwiperSlide>
          <SwiperSlide>
            <Link to="#">
              <Cetagorisv1
                img={womanbag}
                title="Woman Bag"
                content="77 Available"
              />
            </Link>
          </SwiperSlide>
          <SwiperSlide>
            <Link to="#">
              <Cetagorisv1
                img={womandress}
                title="Woman Dress"
                content="55 Available"
              />
            </Link>
          </SwiperSlide>
          <SwiperSlide>
            <Link to="#">
              <Cetagorisv1
                img={manShirt}
                title="Man Shirts"
                content="56 Available"
              />
            </Link>
          </SwiperSlide>
        </Swiper>
        <div className="next-prev">
          <div className="button-next-slide1">
            <FontAwesomeIcon icon={faArrowRight} />
          </div>
          <div className="button-prev-slide1">
            <FontAwesomeIcon icon={faArrowLeft} />
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default CetagorySliderv1;
